import{a as r}from"./chunk-DCHR3B7R.js";import{a as o}from"./chunk-J5FDIWFS.js";import{a as e,m as a}from"./chunk-HBP5N4FR.js";a();import t from"react";var D=p=>t.createElement(r,{label:"Data"},t.createElement(o,e({},p))),i=D;export{i as a};
//# sourceMappingURL=chunk-NESCYEWE.js.map
